var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 1051",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1925 883.08L1860.93 903.305C1796.86 923.531 1667.64 997.583 1539.5 988.002C1412.38 977.357 1297.54 944.872 1169.41 904.42C1041.27 863.968 792.636 795.32 664.5 865.578C537.381 936.901 514.542 947.548 386.407 1008.23C258.271 1068.9 130.135 1028.45 66.0676 1008.23L2 988L1.99963 950.272L66.0673 970.498C130.135 990.724 258.271 1031.18 386.406 970.498C514.542 909.821 537.381 899.174 664.5 827.851C792.635 757.593 1041.27 826.241 1169.41 866.693C1297.54 907.144 1412.38 939.63 1539.5 950.275C1667.64 959.856 1796.86 885.804 1860.93 865.578L1925 845.352L1925 883.08Z",
    fill: "#E7F8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1934 864.405L1869.93 883.086C1805.86 901.768 1676.64 970.165 1548.5 961.316C1421.38 951.484 1306.54 921.479 1178.41 884.116C1005.5 840.43 746.5 815.69 564.5 898C433.954 957.04 512.543 923.953 384.407 979.998C256.272 1036.04 128.136 998.679 64.0679 979.998L0.000244141 961.316V-1.49976H64.068C128.136 -1.49976 256.272 -1.49976 384.407 -1.49976C512.543 -1.49976 640.679 -1.49976 767.798 -1.49976C895.933 -1.49976 1024.07 -1.49976 1152.2 -1.49976C1280.34 -1.49976 1408.48 -1.49976 1535.59 -1.49976C1663.73 -1.49976 1791.87 -1.49976 1855.93 -1.49976H1920L1934 864.405Z",
    fill: "url(#paint0_linear_2448_2095)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1920 470L1867.2 479.583C1812.8 489.167 1707.2 508.333 1600 508.333C1492.8 508.333 1387.2 489.167 1280 479.583C1172.8 470 1067.2 470 960 498.75C852.8 527.5 747.2 585 640 613.75C532.8 642.5 427.2 642.5 320 632.917C212.8 623.333 107.2 604.167 52.7999 594.583L0 585V815H52.7999C107.2 815 212.8 815 320 815C427.2 815 532.8 815 640 815C747.2 815 852.8 815 960 815C1067.2 815 1172.8 815 1280 815C1387.2 815 1492.8 815 1600 815C1707.2 815 1812.8 815 1867.2 815H1920V470Z",
    fill: "url(#paint1_linear_2448_2095)",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2469 127.75L2382.2 176.708C2295.4 225.667 2121.8 323.583 1948.2 313.792C1774.6 304 1601 186.5 1427.4 157.125C1253.8 127.75 1080.2 186.5 906.6 225.667C733 264.833 559.4 284.417 385.8 255.042C212.2 225.667 38.6003 147.333 -48.1997 108.167L-135 69V539H-48.1997C38.6003 539 212.2 539 385.8 539C559.4 539 733 539 906.6 539C1080.2 539 1253.8 539 1427.4 539C1601 539 1774.6 539 1948.2 539C2121.8 539 2295.4 539 2382.2 539H2469V127.75Z",
    fill: "url(#paint2_linear_2448_2095)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2448_2095",
    x1: 960,
    y1: 40.0004,
    x2: 960,
    y2: 1323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619792,
    stopColor: "#009ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2448_2095",
    x1: 960,
    y1: 470,
    x2: 960,
    y2: 815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2448_2095",
    x1: 1167,
    y1: 69,
    x2: 1167,
    y2: 539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackground);
export default __webpack_public_path__ + "static/media/header_background.09f1169b0abe19e55612fe57fd77fc71.svg";
export { ForwardRef as ReactComponent };